import { SupplierEntity, SupplierFilter } from '../../models'

export const SET_SUPPLIERS = 'SET_SUPPLIERS'
export const SET_SUPPLIERS_LOADED = 'SET_SUPPLIERS_LOADED'
export const SET_SUPPLIER_FILTER = 'SET_SUPPLIER_FILTER'
export const SET_SELECTED_SUPPLIER = 'SET_SELECTED_SUPPLIER'

export interface SupplierState {
  suppliers: SupplierEntity[]
  isSuppliersLoaded: boolean
  supplierFilter: SupplierFilter
  selectedSupplier?: SupplierEntity
}

interface SetSupplierFilterAction {
  type: typeof SET_SUPPLIER_FILTER
  payload: SupplierFilter
}

interface SetSelectedSupplierAction {
  type: typeof SET_SELECTED_SUPPLIER
  payload?: SupplierEntity
}

interface SetSuppliersAction {
  type: typeof SET_SUPPLIERS
  payload: SupplierEntity[]
}

interface SetSuppliersLoadedAction {
  type: typeof SET_SUPPLIERS_LOADED
  payload: boolean
}

export type SupplierAction =
  | SetSupplierFilterAction
  | SetSelectedSupplierAction
  | SetSuppliersAction
  | SetSuppliersLoadedAction
